export type Player = {
    role: string;
    position: string;
    name: string;
}

export type PlayersState = {
    year: number;
    graduation: { [year: number]: Player[] };
}

export const INITIAL_STATE: PlayersState = {
    year: 2020,
    graduation: {}
}
